<template>
  <div>
    <div id="registrationDetail" class="modal right fade registrationComponent" role="dialog">
      <div class="modal-dialog modal-lg">
        <loader :loadingStatus="loaderStatus || initialLoader"></loader>
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <img src="/static/images/icons/ul_close_icon.svg" class="address-images" @click="closeRegistrationDetails" />
            <div class="view-record">{{ $t('viewRecord') }}</div>
          </div>
          <div
            class="modal-body mx-ht scrollable-content"
          >
            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('productName')}}</div>
              <div class="col-md-5 details-text">
                {{ data.Product }}
              </div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('country')}}</div>
              <div class="col-md-5 details-text">
                  <span
                  class="flag-icon flag-icon-squared"
                  :class="countryFlag(data['Country Code'])"
                  ></span>
                  {{ translateCountry(data["Country"]) }}
              </div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit pb-5">
              <div class="col-md-7 header-name">{{$t('productStatus')}}</div>
              <div class="col-md-5 details-text-status">
                <span v-if="this.$i18n.locale === 'English'"
                  class="registration-status"
                  :class="statusColor(data.Status, data.save_draft)"
                >{{ translateStatus(data.Status, data.save_draft) }} </span>
                <span v-else
                  class="registration-status"
                  :class="statusColor(data.Status, data.save_draft)"
                >{{ translateStatus(data.Status, data.save_draft) }}</span>
              </div>
            </div>

            <div class="col-md-12">
              <hr />
            </div>

            <div>
              <div class="col-md-12 padding-reset padding-top-edit">
                <div class="col-md-7 header-name">{{$t('manufacturer')}}</div>
                <div class="col-md-5 details-text">{{ data["Manufacturer"] }}</div>
              </div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('productCategory')}}</div>
              <div class="col-md-5 details-text">
                <div v-if="data['registrationType']">{{ data["registrationType"] }}</div>
                <div v-else>-</div>
              </div>
            </div>

             <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('productClass')}} ({{$t('in')}} {{ data["Country"] }})</div>
              <div class="col-md-5 details-text">
                <div
                  v-if="data['Device class']"
                >{{ data["Device class"] }}</div>
                <div v-else>-</div>
              </div>
            </div>
            <div class="col-md-12">
              <hr />
            </div>

            <div
                class="col-md-12 padding-reset padding-top-edit editLocalDistributor"
                v-if="roleId !== 6"
              >
                <div class="col-md-7 header-name">{{$t('brandName')}}</div>
                <div class="col-md-5 details-text">
                  <div v-if="data['Local distributor']">
                    {{ data['Local distributor'] }}
                  </div>
                  <div v-else>-</div>
                </div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('barcode')}}</div>
              <div class="col-md-5 details-text">
                <div v-if="data['Barcode']">
                  <div v-for="partNo of data['Barcode'].split(',')" :key="partNo">
                    <span>{{ partNo }}</span>
                  </div>
                </div>
                <div v-else>-</div>
              </div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('modelName')}}</div>
              <div class="col-md-5 details-text">
                <div v-if="data['Device UDI']">
                  <div v-for="model of data['Device UDI'].split(',')" :key="model">
                    <span>{{ model }}</span>
                  </div>
                </div>
                <div v-else>-</div>
              </div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('description')}}</div>
              <div class="col-md-5 details-text">
                <div v-if="data['Configuration']">{{ data["Configuration"] }}</div>
                <div v-else>-</div>
              </div>
            </div>

            <div class="col-md-12">
              <hr />
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('certificationNumber')}}</div>
              <div class="col-md-5 details-text">
                <span v-if="!data['submissionNumber']">-</span>
                <span v-else>{{ data["submissionNumber"] }}</span>
              </div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('certificationURL')}}</div>
              <div class="col-md-5 details-text">{{data["Record number"] || '-'}}</div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('managedBy')}}</div>
              <div class="col-md-5 details-text">{{ data["Local representative"] || "-" }}</div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('accreditedBy')}}</div>
              <div class="col-md-5 details-text">
                <div v-if="data['Issued by']">{{ data["Issued by"] }}</div>
                <div v-else>-</div>
              </div>
            </div>

            <div class="col-md-12">
              <hr />
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('registered')}}</div>
              <div class="col-md-5 details-text">
                <span
                  v-if="
                    data['rawSubmissionDate'] !== 'N/A' &&
                      data['rawSubmissionDate'] !== 'Invalid date' &&
                      data['rawSubmissionDate']
                  "
                >{{ translate(data["rawSubmissionDate"]) }}</span>
                <span v-else>-</span>
              </div>
            </div>
            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('approved')}}</div>
              <div class="col-md-5 details-text">
                <span
                  v-if="
                    data['Status'] === 'Pending' &&
                      data['notYetApprovedStatus']
                  "
                >{{$t('notYetApproved')}}</span>
                <span v-else>
                  <span
                    v-if="
                      data['rawApprovalDate'] !== 'Invalid date' &&
                        data['rawApprovalDate'] !== 'N/A' &&
                        data['rawApprovalDate']
                    "
                  >{{ translate(data["rawApprovalDate"]) }}</span>
                  <span v-else>-</span>
                </span>
              </div>
            </div>
              <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('maintenanceDate')}}</div>
              <div class="col-md-5 details-text">
                <span
                  v-if="
                    data['Maintenance date'] !== 'N/A' &&
                      data['Maintenance date'] !== 'Invalid date' &&
                      data['Maintenance date']
                  "
                >{{ translate(data['Maintenance date']) }}</span>
                <span v-else>-</span>
              </div>
            </div>
            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('nextMaintenanceDate')}}</div>
              <div class="col-md-5 details-text">
                <span
                  v-if="
                    data['Next maintenance date'] !== 'N/A' &&
                      data['Next maintenance date'] !== 'Invalid date' &&
                      data['Next maintenance date']
                  "
                >{{ translate(data['Next maintenance date']) }}</span>
                <span v-else>-</span>
              </div>
            </div>
            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('expires')}}</div>
              <div class="col-md-5 details-text">
                <span
                  v-if="
                    !data['notYetApprovedStatus'] &&
                      data['doesNotExpireStatus']
                  "
                >{{$t('doesNotExpire')}}</span>
                <span v-else-if="data['notYetApprovedStatus']"></span>
                <span v-else>
                  <span
                    v-if="
                      data['rawExpirationDate'] !== 'N/A' &&
                        data['rawExpirationDate'] !== 'No expiration' &&
                        data['rawExpirationDate'] !== 'Invalid date' &&
                        data['rawExpirationDate']
                    "
                  >
                    {{ translate(data["rawExpirationDate"]) }} (<span v-if='data["resolve"] > 0'>{{$t('in')}} </span>{{ Math.abs(data["resolve"]) }} {{$t('days')}}<span v-if='data["resolve"] < 0 '> {{$t('ago')}}</span>)
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
            </div>
            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('alertDateInViewRecord')}}</div>
              <div class="col-md-5 details-text">
                <span v-if="data['doesNotExpireStatus']">N/A</span>
                <span v-else-if="!data['alertBeforeMonths']">-</span>
                <span v-else>
                  {{ data["alertBeforeMonths"] }} {{$t('methodsBeforeExpiration')}}
                </span>
              </div>
            </div>
            <div class="col-md-12">
              <hr />
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name ellipsis" :title="loggedInUser.company + ' ' + $t('contact')">{{ loggedInUser.company }} {{$t('contact')}}</div>
              <div class="col-md-5 details-text">
                <span class="details-text">
                  {{ data["medCompContact"] || "-" }}
                  <span v-if="data['medCompContact']">
                    <email-popover
                      :permissions="permissions"
                      :flag="'envelope'"
                      :mode="'1'"
                      :id="data['registrationId']"
                      :sendTo="'2'"
                      @openRegistrationEmailPopup="openRegistrationEmailPopup"
                    ></email-popover>
                  </span>
                </span>
              </div>
            </div>

            <div class="col-md-12">
              <hr />
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('standards')}}</div>
              <div class="col-md-5 details-text">{{ data["standards"] || "-" }}</div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('ordinance')}}</div>
              <div class="col-md-5 details-text">{{ data['ordinance'] || '-' }}</div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('importedProduct')}}</div>
              <div class="col-md-5 details-text">
                <div v-if="data['imported_product'] === true">{{this.$i18n.locale === 'Portuguese'?'Sim':'Yes'}}</div>
                <div v-if="data['imported_product'] === false">{{this.$i18n.locale === 'Portuguese'?'Não':'No'}}</div>
                <div v-if="(data['imported_product'] !== true) && (data['imported_product'] !== false)">-</div>
              </div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('importer')}}</div>
              <div class="col-md-5 details-text">
                {{ data['imported'] || '-'}}
              </div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('requester')}}</div>
              <div class="col-md-5 details-text">{{ data['requester'] || '-'}}</div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('tradeRepresentative')}}</div>
              <div class="col-md-5 details-text">{{ data['trade_representative'] || '-' }}</div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('status')}}</div>
              <div class="col-md-5 details-text">{{ data['inputStatus'] || '-' }}</div>
            </div>

            <div class="col-md-12">
              <hr />
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('testReport')}}</div>
              <div class="col-md-5 details-text">
                <div v-if="data['test_report']">{{ data["test_report"] }}</div>
                <template v-if="data['test_report_attachments']">
                  <div v-for="(file,index) in data['test_report_attachments']" :key="index">
                    <a v-if="!checkConfidentiality(file.highlyConfidential)"
                      href="javascript:void(0)"
                      @click="downloadFile(file,data['registrationId'])"
                      class="link"
                    >{{ file.attachmentLink.split("/")[file.attachmentLink.split("/").length - 1] }}</a>
                  </div>
                </template>
                <template v-else>-</template>
              </div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('productCertificate')}}</div>
              <div class="col-md-5 details-text">
                <div v-if="data['product_certificate']">{{ data["product_certificate"] }}</div>
                <template v-if="data['product_certificate_attachments']">
                  <div v-for="(file,index) in data['product_certificate_attachments']" :key="index">
                    <a
                    v-if="!checkConfidentiality(file.highlyConfidential)"
                      href="javascript:void(0)"
                      @click="downloadFile(file,data['registrationId'])"
                      class="link"
                    >{{ file.attachmentLink.split("/")[file.attachmentLink.split("/").length - 1] }}</a>
                  </div>
                </template>
                <template v-else>-</template>
              </div>
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('barcodeFile')}}</div>
              <div class="col-md-5 details-text">
                <div v-if="data['barcodeFile']">{{ data["barcodeFile"] }}</div>
                <template v-if="data['barcode_attachments']">
                  <div v-for="(file,index) in data['barcode_attachments']" :key="index">
                    <a
                    v-if="!checkConfidentiality(file.highlyConfidential)"
                      href="javascript:void(0)"
                      @click="downloadFile(file,data['registrationId'])"
                      class="link"
                    >{{ file.attachmentLink.split("/")[file.attachmentLink.split("/").length - 1] }}</a>
                  </div>
                </template>
                <template v-else>-</template>
              </div>
            </div>
            <div  v-if="data['maintenanceDocuments']">
              <div class="col-md-12 padding-reset padding-top-edit">
                <div class="col-md-7 header-name">{{$t('maintenanceDocuments')}}</div>
                <div class="col-md-5 details-text">
                  <template v-if="data['maintenanceDocuments']">
                    <div v-for="(file,index) in data['maintenanceDocuments']" :key="index">
                      <a v-if="!checkConfidentiality(file.highlyConfidential)"
                        href="javascript:void(0)"
                        @click="downloadFile(file,data['registrationId'])"
                        class="link"
                      >{{ file.attachmentLink.split("/")[file.attachmentLink.split("/").length - 1] }}</a>
                    </div>
                  </template>
                  <template v-else>-</template>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <hr />
            </div>

            <div class="col-md-12 padding-reset padding-top-edit">
              <div class="col-md-7 header-name">{{$t('comments')}}</div>
              <div class="col-md-5 details-text">
                <span v-if='data["Comments"]'>{{ data["Comments"] }}</span>
                <span v-else>{{ this.$i18n.locale === 'Portuguese' ? 'Nenhum' : 'None' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <email-share-popup
      :meta="emailMeta"
      :data="data"
      :relatedCertificates="relatedCertificates"
      :loggedInUser="loggedInUser"
      :roleId="roleId"
      :permissions="permissions"
    ></email-share-popup>
    <email-share-contact-popup :data="data" :loggedInUser="loggedInUser"></email-share-contact-popup>
  </div>
</template>

<script>
import $ from 'jquery';
import DatePicker from 'vue2-datepicker';
import cloneDeep from 'clone-deep';
import * as moment from 'moment';
import Loader from '../UIComponents/Loader.vue';
import EmailPopover from '../UIComponents/EmailPopover.vue';
import EmailSharePopup from './EmailSharePopup.vue';
import EmailShareContactPopup from './EmailShareContactPopup.vue';
import { downloadFile } from '../../apis/fileUploadDownload';
import RolesMixin from '../UIComponents/mixins/rolesMixin';

export default {
  mixins: [RolesMixin],
  components: {
    DatePicker,
    Loader,
    EmailPopover,
    EmailSharePopup,
    EmailShareContactPopup,
  },
  props: {
    dashboardRecordsFlag: Boolean,
    permissions: Array,
    countryCertificateType: Array,
    dataRow: Object,
    archivedFlag: Boolean,
    reportFlag: Boolean,
    totalRecordsData: Array,
  },
  data() {
    return {
      emailMeta: {},
      loaderStatus: false,
      loggedInUser: '',
      data: {},
      initialLoader: false,
      highlyConfidentialPermission: '',
      rolesData: {},
      relatedCertificates: []
    };
  },
  async created() {
    this.loggedInUser = JSON.parse(localStorage.getItem('userData'));
    this.roleId = this.loggedInUser.role_id;
    this.rolesData = await this.getRolesInfo();
  },
  beforeDestroy() {
    $('.modal-backdrop').remove();
  },
  watch: {
    dataRow: {
      deep: true,
      async handler() {
        this.updateInitialRegistration();
      },
    },
  },
  filters: {
    date(value) {
      if (value) return moment.utc(value).format('DD MMM YYYY');
      return '';
    },
  },
  mounted() {
    $('[data-toggle=popover]').popover({
      html: true,
      content() {
        return $('#popover-content').html();
      },
    });
    $('#registrationDetail').on('show.bs.modal', async () => {
      $('#registrationDetail .modal-body').animate({ scrollTop: 0 }, 'slow');
      setTimeout(() => {
        $('.modal-backdrop')
          .css('background', 'rgba(255, 255, 255, 0.65)')
          .addClass('registration-details');
      }, 10);
    });
    $('#registrationDetail').on('hidden.bs.modal', () => {
      if (this.dashboardRecordsFlag) {
        this.$emit('dashboardWidgets');
      }
      $('.modal-backdrop .registration-detail').remove();
    });
  },
  methods: {
    async downloadFile(file, registrationId) {
      await downloadFile(registrationId, file);
    },
    translateDate(value) {
      if (value) return moment.utc(value).format('DD MMM YYYY');
      return '';
    },
    translate(date) {
      if (date === 'N/A') {
        return this.$i18n.locale === 'Portuguese' ? 'N/D' : date;
      }
      const formattedDate = this.$i18n.locale === 'Portuguese' ? moment(date).format('DD/MM/YYYY') : moment(date).format('MM/DD/YYYY');
      return formattedDate;
    },
    translateCountry(name) {
      if (name === 'Not Available') {
        if (this.$i18n.locale === 'English') {
          return 'Not Available';
        }
        return 'Não disponível';
      }
      return name;
    },
    translateStatus(name, saveDraft) {
      if (saveDraft && this.$i18n.locale === 'English') {
        name = 'Draft';
      } else if (saveDraft && this.$i18n.locale === 'Portuguese') {
        name = 'Rascunho';
      }
      if (this.$i18n.locale === 'Portuguese' && !saveDraft) {
        name = name === 'Expiring soon' ? 'Expiring_soon' : name;
        const data = {
          Active: 'Ativo', Expired: 'Expirado', Expiring_soon: 'Expirando Em Breve', Pending: 'Pendente', Archived: 'Arquivado',
        };
        return data[name];
      }
      return name;
    },
    openRegistrationEmailPopup(data) {
      this.emailMeta = data;
      $('#registrationEmailLink').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    dateStatus(value) {
      return moment().diff(moment(value), 'days');
    },
    updateInitialRegistration() {
      console.log(this.dataRow);
      this.data = cloneDeep(this.dataRow);
    },
    checkConfidentiality(confidentiality) {
      this.highlyConfidentialPermission = this.permissions.indexOf('HIGHLY_CONFIDENTIAL') > -1;
      return confidentiality && !this.highlyConfidentialPermission;
    },
    closeRegistrationDetails() {
      setTimeout(() => {
        $('#registrationDetail').modal('hide');
      }, 0);
    },
    countryFlag(code) {
      if (!code) {
        return '';
      }
      return `flag-icon-${code.toLowerCase()}`;
    },
    statusColor(status, saveDraft) {
      if (saveDraft) {
        return 'registration-status-title-draft';
      }
      if (status && !saveDraft) {
        if (status.toLowerCase() === 'active') {
          return 'registration-status-title-active';
        }
        if (status.toLowerCase() === 'pending') {
          return 'registration-status-title-pending';
        }
        if (status.toLowerCase() === 'expiring soon') {
          return 'registration-status-title-expiring';
        }
        if (status.toLowerCase() === 'expired') {
          return 'registration-status-title-expired';
        }
        if (status.toLowerCase() === 'archived') {
          return 'registration-status-title-archived';
        }
      }
      return '';
    },
    moment(date) {
      return moment.utc(date);
    },
  },
};
</script>

<style scoped>
.modal-dialog .spinnerTop {
    height: 80%;
    position: fixed;
    width: 100%;
    left: 0px;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.7);
}
.modal.right .modal-body {
  padding-top: 68px;
}
.scrollable-content {
  flex-grow: 1;
  overflow: auto;
  overflow-x: hidden;
  min-height: 0;
}

.scrollable-content::-webkit-scrollbar {
  width: 6px;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;

}
.view-record {
  font-size: 20px;
  color: #1A1A1A;
  font-weight: 600;
  margin-top: 4px;
}
.address-images {
  position: absolute;
  right: 24px;
  top: 24px;
  cursor: pointer;
}
.modal-header {
  background-color: #ffffff;
  border-bottom: 1px solid #D3D3D3;
  height: 60px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  /* border-radius: 6px; */
}
.modal.right .modal-body::-webkit-scrollbar {
  width: 6px;
}
.modal.right .modal-body::-webkit-scrollbar-thumb {
  background-color: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  outline: none;
}
.modal.right .modal-body::-webkit-scrollbar-track-piece:start {
  margin-top: 80px;
}
.modal.right .modal-body::-webkit-scrollbar-track {
  box-shadow: none !important;
}
hr {
  border-top: 0.6px solid #D3D3D3;
  margin-left: 25px;
  margin-right: 18px;
  margin-bottom: 10px;
}
.header-name {
  font-size: 16px;
  color: #3E3E3E;
  font-weight: 600;
  padding-left: 40px;
}
.header-name::after {
  content: ':';
}
.padding-reset {
  padding-right: 15px;
}
.details-text {
  font-size: 16px;
  font-weight: 400;
  color: #3E3E3E;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}
.details-text-status {
  font-size: 14px;
}
.modal.right .modal-content {
  height: 80%;
  border-radius: 6px;
}
.modal.right.fade.in .modal-dialog {
  margin: 80px auto;
  min-width: 720px;
  right: unset;
}
.modal.right .modal-dialog {
  position: relative;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.modal.right .modal-body {
  padding-bottom: 10px !important;
}
.mx-ht {
  max-height: calc(100% - 15px) !important;
}
.pb-5 {
  padding-bottom: 5px;
}
#registrationDetail .modal-header {
  max-height: 114px;
}
@media screen and (max-width: 767px){
  #registrationDetail .modal-header {
    max-height: 170px;
  }
}
</style>
